import { Filter } from '@ph-model/filters/filter';

export class ContractFilter {
  constructor(
    public name: string,
    public selected: boolean = false,
    public batch: Filter[] = [],
    public display: boolean = true) {}
}
